<template>
  <div class="bulletinsList">
    <h3>Bulletins ornithologiques</h3>
    <table class="table">
      <thead>
      <tr>
        <th scope="col">Publication</th>
        <th scope="col">Lien</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(bulletin, index) in sortedBulletins" :key="index">
        <th>{{bulletin.publicationDate}}</th>
        <th>
          <a href="#" @click="downloadBulletin(bulletin)" target="_blank">
            <img src="/images/icone_pdf.png" alt=""/>
            Ouvrir le bulletin
          </a>
        </th>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
  import _ from 'lodash';

  export default {
    name: 'member-bulletins-list',
    computed: {
      ...mapState({
        bulletins: state => state.bulletins.all
      }),
      sortedBulletins() {
        return _.orderBy(this.bulletins, [ 'publicationDate' ], [ 'desc' ]);
      },
      ...mapGetters('account', {
        getUserInfos: 'getUserInfos'
      }),
      user() {
        return this.getUserInfos;
      }
    },
    methods: {
      generateUrl(bulletin) {
        return process.env.VUE_APP_BACKEND + '/bulletins/' + bulletin.id + '/download?userId=' + this.user.id;
      },
      downloadBulletin(bulletin) {
        window.open(this.generateUrl(bulletin));
      }
    }
  };
</script>

<style scoped></style>
